<div>
  <h6 class="odx-title-6" i18n="@@global.standardRooms">Standard Rooms</h6>

  <app-floorplan-menu-item-buttons>
    <button
      odxButton
      class="standard-room"
      (click)="addStandardRoom()"
      [odxTooltip]="tooltipText"
      [odxTooltipOptions]="{ position: 'bottom-start' }"
      draggable="true"
      (dragstart)="dragStandardRoom()"
    >
      <odx-icon name="plus" size="medium"></odx-icon>
    </button>
    <app-toggle-visibility-button
      [visible]="floorplanState.standardRoomsVisible"
      (toggleEvent)="floorplanState.standardRoomsVisible = $event"
    >
    </app-toggle-visibility-button>

    <app-toggle-item-text-visibility-button
      [itemTextVisible]="floorplanState.standardRoomsItemTextVisible"
      (toggleEvent)="updateStandardRoomsItemTextVisibility($event)"
    ></app-toggle-item-text-visibility-button>
    <app-toggle-lock-button
      [locked]="floorplanState.standardRoomsLocked"
      (toggleEvent)="floorplanState.standardRoomsLocked = $event"
    >
    </app-toggle-lock-button>
  </app-floorplan-menu-item-buttons>
</div>
